import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import { getLocalizedMessage, SupportedLanguage } from "@pimo/pimo-l10n";

interface PasswordResetConfirmDialogProps {
  open: boolean;
  language: SupportedLanguage;
  onClose: () => void;
}

export const PasswordResetConfirmDialog: React.FC<
  PasswordResetConfirmDialogProps
> = ({ open, language, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
          bgcolor: "#fff",
        },
      }}
    >
      <DialogContent sx={{ p: 4, textAlign: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            mb: 3,
          }}
        >
          <img
            src="/pimo-large.svg"
            alt="Pimo Logo"
            style={{ height: 60, marginRight: 8 }}
          />
        </Box>

        <Box sx={{ mb: 3 }}>
          <MarkEmailReadOutlinedIcon
            sx={{
              fontSize: 80,
              color: "#3ec6ff",
            }}
          />
        </Box>

        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: "#222",
            mb: 2,
          }}
        >
          {getLocalizedMessage(
            language,
            "auth.resetPassword.confirmationTitle"
          )}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#666",
            lineHeight: 1.6,
            mb: 4,
          }}
        >
          {getLocalizedMessage(language, "auth.resetPassword.confirmationText")}
        </Typography>

        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            py: 1.2,
            px: 4,
            fontSize: "1rem",
            borderRadius: 6,
            bgcolor: "#3ec6ff",
            color: "#fff",
            fontWeight: 500,
            textTransform: "none",
            boxShadow: "none",
            ":hover": { bgcolor: "#1da1f2", boxShadow: "none" },
          }}
        >
          {getLocalizedMessage(
            language,
            "auth.resetPassword.buttons.backToLogin"
          )}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
